import { Box, type BoxProps } from '@mantine/core';
import { memo } from 'react';

export type TrProps = BoxProps & {
  onClick?: () => void;
  children: React.ReactNode;
  gridTemplateColumns?: string;
};

export const Tr: React.FC<TrProps> = memo(
  ({ children, gridTemplateColumns, ...props }) => (
    <Box
      sx={theme => ({
        display: 'grid',
        borderBottom: `1px solid ${theme.colors.gray[1]}`,
        gridTemplateColumns,
      })}
      {...props}
    >
      {children}
    </Box>
  ),
);
